import axios from 'axios';
import constantes from "../constantes";
import store from "../store";

const PREFIJO="/api/PrtVnt/";

export default {
    nuevaCotizacion(pasos){
        let accesorios=[];
        let resumen={
            paquetes:[],
            totalpaquetes:0,
            accesorios:[],
            totalAccesorios:0,
            total:0,
        };
        pasos[2].accesorios.individuales.map(function(item){
            if(item.id){
                accesorios.push({ndt1:item.id});
                resumen.accesorios.push({detalle:item.dt7||item.dt2,precio:item.ndt2});
                resumen.totalAccesorios+=item.ndt2;
            }
        });
        pasos[2].accesorios.kit.map(function(item){
            if(item.id){
                accesorios.push({ndt1:item.id});
                resumen.accesorios.push({detalle:item.dt7||item.dt2,precio:item.ndt2});
                resumen.totalAccesorios+=item.ndt2;
            }
        });
        pasos[3].resumen.map(function(item){
            resumen.paquetes.push({detalle:item.dt1,precio:item.ndt1});
            resumen.totalpaquetes+=item.ndt1;
        });
        resumen.total=resumen.totalpaquetes+resumen.totalAccesorios+constantes.funciones.sumar3('ndt3',pasos[2].accesorios.cupones);
        const dto = {
            id:store.getters.getUsuario.ndt1,
            dt12:constantes.Constantes.enumeraciones.fuente,
            dt13:constantes.Constantes.enumeraciones.producto,
            dt14:constantes.Constantes.enumeraciones.linea,
            dt18:process.env.VUE_APP_MARCA,
            ndt2:constantes.Constantes.enumeraciones.campana.online,
            ndt6:pasos[3].agencia.id,
            ndt8:pasos[2].color.id,//color
            ndt9:pasos[2].paquete.id,//formulario,//paquete
            ndt10:resumen.total,
            elements:accesorios,//lista de accesorios
            elements2:pasos[2].accesorios.individuales,
            elements3:pasos[2].accesorios.kit,
            elements4:pasos[2].accesorios.cupones,
        };
        return axios.post(`${PREFIJO}VmCrOprL`,dto);
    }
}
